import "babel-polyfill";
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import VeeValidate, { Validator } from 'vee-validate';
import nl from 'vee-validate/dist/locale/nl';
import setupCityRule from '@/rules/city_name'; 

import VueKindergarten from 'vue-kindergarten';

import VueMaterial from 'vue-material';
Vue.use(VueMaterial);

import App from '@/App.vue';
import router from '@/routes';
import store from '@/store';
import config from '@/lib/config.js';
import messages from '@/i18n';
import mixins from '@/lib/mixins';


import '@/styles/build.scss';
global.config = config;

import swal from 'sweetalert2';
global.swal = swal;

/**
 * Mixins
 */
    let allMixins = {...mixins};
    const mixinMethods = {
        methods: allMixins,
    };
    Vue.mixin(mixinMethods);
/**
 * End Mixins
 */


 // BUGSNAG
const bugsnag = require('bugsnag-js')
const bugsnagClient = bugsnag('4d7454f6760030cc4cf0329570d43ff0')

// Initialize Vue before we start the BugsnagVue plugin
const bugsnagVue = require('bugsnag-vue')

bugsnagClient.use(bugsnagVue(Vue))




// CREATE AXTIOS
let  axiosLastError = false;
let  axiosInstance  = axios.create({
    baseURL: config.apiUrl,
    headers: {
        'Accept'       : 'application/json'
    },
    validateStatus: function (status) {
        return status >= 200 && status < 300 || status == 304; // default
    },
    /* other custom settings */
});

// Dirty way of getting the Axios error
axiosInstance.interceptors.response.use((response) => {
  Vue.prototype.$axiosLastError = false;
  return response;
}, (error) => {
  Vue.prototype.$axiosLastError = error;
  throw error;
});


Vue.prototype.$axios = axiosInstance;

/**
 * Start VeeValidate
 */
    const veeConfig = {
        events: 'change|blur'
    }
    Vue.use(VeeValidate, veeConfig);
    
    setupCityRule();
    
/**
 * End VeeValidate
 */

/**
 * Start Vue-i18n
 */
    
    Vue.use(VueI18n);
    // Get all translated messages
    // Set up the translations
    const i18n = new VueI18n({
        locale: 'nl', // set locale
        fallbackLocale: 'nl',
        messages, // set locale messages
    });

    Validator.localize('nl',nl);
/**
 * End Vue-i18n
 */


// PERMISSIONS
Vue.use(VueKindergarten, {
    // Getter of your current user.
    // If you use vuex, then store will be passed
    child: (store) => {
      return store.state.user.data;
    }
});


Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0
  });
  return formatter.format(value);
});




const app = new Vue({
    router,
    i18n,
    store,
    ...App,

    computed: {

      disciplineTypes() {
      
        return  [

                      {
                              label: 'Verzorgende IG',
                              value: 'Verzorgende IG',
                      },

                      {
                              label: 'Begeleider',
                              value: 'Begeleider',
                      },

                      {
                              label: 'Verpleegkundige',
                              value: 'Verpleegkundige',
                      },

                      {
                              label: 'Persoonlijk begeleider',
                              value: 'Persoonlijk begeleider',
                      },

                      {
                              label: 'Gedragswetenschapper',
                              value: 'Gedragswetenschapper',
                      },

                      {
                              label: 'Verpleegkundig specialist',
                              value: 'Verpleegkundig specialist',
                      },

                      {
                              label: 'SPV\'er',
                              value: 'SPV\'er',
                      },

                      {
                              label: 'GZ psycholoog',
                              value: 'GZ psycholoog',
                      },

                      {
                              label: 'Psychiater',
                              value: 'Psychiater',
                      },

                      {
                              label: 'Orthopedagoog',
                              value: 'Orthopedagoog',
                      }, 
                      {
                              label: 'Leerkracht',
                              value: 'Leerkracht',
                      },  
                  ]

      },

      version () {
        return process.env.VERSION+ ' ('+process.env.NODE_ENV + ')'; 
      },

      isMobile(){
        if ( (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1) ) {
            // WEL Mobiel
            return true;
        } else { 
            // NIET MOBIEL
            return false;
        }
    },
    }
});

// DEVELOPMENT NOTIFICATIONS
window.Notify = (msg) => {
    if (!("Notification" in window)) {
        console.log("This browser does not support desktop notification");
        return;
      }
    
      // Let's check whether notification permissions have already been granted
      else if (Notification.permission === "granted") {
        // If it's okay let's create a notification
        new Notification(msg);
      }
    
      // Otherwise, we need to ask the user for permission
      else if (Notification.permission !== "denied") {
        Notification.requestPermission(function (permission) {
          // If the user accepts, let's create a notification
          if (permission === "granted") {
            new Notification(msg);
          }else{
            alert(msg)
          }
        });
      }
}

app.$mount('#app');


// WEBPACK FOOTER //
// ./src/app.js